import { Component, Input } from '@angular/core';

@Component({
  selector: 'finxone-web-frontend-text-skeleton',
  templateUrl: './text-skeleton.component.html',
})
export class TextSkeletonComponent {
  @Input() public contentClass: string;
  @Input() public content = '';
}
